type Historico = {
  fecha: string;
  muestra: string;
  valor: string;
  unidad: string;
  // Compat: antes algunos payloads traían val_ref por item.
  val_ref?: string;
};

export class PrestacionHistorico {
  private prestacion: string;
  private codigo: string[];
  private historico: Historico[];
  private val_ref: string;
  private val_ref_min: number | null;
  private val_ref_max: number | null;

  // Constructor con valores por defecto
  constructor(
    prestacion: string = "UNKNOWN",
    codigo: string[] = ["000"],
    historico: Historico[] = [],
    val_ref: string = "",
    val_ref_min: number | null = null,
    val_ref_max: number | null = null
  ) {
    this.prestacion = prestacion;
    this.codigo = codigo;
    this.historico = historico;
    this.val_ref = val_ref;
    this.val_ref_min = val_ref_min;
    this.val_ref_max = val_ref_max;
  }

  // Método get para prestacion
  public getPrestacion(): string {
    return this.prestacion;
  }

  // Método set para prestacion
  public setPrestacion(value: string): void {
    this.prestacion = value;
  }

  // Método get para codigo
  public getCodigo(): string[] {
    return this.codigo;
  }

  // Método set para codigo
  public setCodigo(value: string[]): void {
    this.codigo = value;
  }

  // Método get para historico
  public getHistorico(): Historico[] {
    return this.historico;
  }

  // Método set para historico
  public setHistorico(value: Historico[]): void {
    this.historico = value;
  }

  // Método get para val_ref
  public getValRef(): string {
    return this.val_ref;
  }

  // Método set para val_ref
  public setValRef(value: string): void {
    this.val_ref = value;
  }

  public getValRefMin(): number | null {
    return this.val_ref_min;
  }

  public setValRefMin(value: number | null): void {
    this.val_ref_min = value;
  }

  public getValRefMax(): number | null {
    return this.val_ref_max;
  }

  public setValRefMax(value: number | null): void {
    this.val_ref_max = value;
  }

  // Método toString
  public toString(): string {
    return `Prestacion: ${this.prestacion}, Codigo: ${this.codigo.join(
      ", "
    )}, Historico: ${JSON.stringify(this.historico)}`;
  }

  // Método fromCollection para crear una colección de instancias de PrestacionHistorico desde un array de objetos
  public static fromCollection(data: any[]): PrestacionHistorico[] {
    return data.map((resultado) => {
      const prestacion = resultado.Prestacion ?? "UNKNOWN";
      const codigo = resultado.codigo ?? ["000"];
      const val_ref = resultado.val_ref ?? "";

      const parseNullableNumber = (raw: any): number | null => {
        if (raw === null || raw === undefined || raw === '') return null;
        if (typeof raw === 'number' && Number.isFinite(raw)) return raw;
        const n = Number(String(raw).replace(',', '.'));
        return Number.isFinite(n) ? n : null;
      };

      const val_ref_min = parseNullableNumber(resultado.val_ref_min);
      const val_ref_max = parseNullableNumber(resultado.val_ref_max);

      const historico = (resultado.historico ?? []).map((item: any) => ({
        fecha: item.fecha ?? "01/01/2000",
        muestra: item.muestra ?? "N/A",
        valor: item.valor ?? "0",
        unidad: item.unidad ?? "N/A",
        val_ref: item.val_ref ?? ""
      }));
      return new PrestacionHistorico(prestacion, codigo, historico, val_ref, val_ref_min, val_ref_max);
    });
  }
}
